import type { LinkEmbedVendor } from './types';
import { youtubeVendor } from './Youtube';

// Add one file per vendor + a registry entry here when a second vendor is added.
export const vendors: Record<string, LinkEmbedVendor> = {
  youtube: youtubeVendor,
};

export type { LinkEmbedVendor };
